import AxiosControl from '../components/axios/AxiosControl'
import { toastSuccess, toastError } from '../components/swal/toast'
const Axios = AxiosControl()

export const getGroups = () => async (dispatch) => {
    dispatch({ type: 'DASHBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/groups', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'GROUPS_SUCCESS', payload: data.groups })
        }
    } catch (error) {
        dispatch({ type: 'DASHBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getSessions = (filter) => async (dispatch) => {
    dispatch({ type: 'DASHBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/sessions', {
            params: { filter },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSIONS_SUCCESS', payload: data.sessions })
        }
    } catch (error) {
        dispatch({ type: 'DASHBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getSession = (sessionId) => async (dispatch) => {
    dispatch({ type: 'DASHBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/sessions/' + sessionId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_SUCCESS', payload: data.session })
        }
    } catch (error) {
        dispatch({ type: 'DASHBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const saveAttendance = (sessionId, attendance) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/sessions/attendance', { sessionId, attendance }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
        }
    } catch (error) {
        console.error('Error saveAttendance:', error)
        toastError(error.response?.data?.message || 'Error al guardar asistencia')
    }
}

export const saveContent = (sessionId, content, observations) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/sessions/content', { sessionId, content, observations }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
        }
    } catch (error) {
        console.error('Error saveContent:', error)
        toastError(error.response?.data?.message || 'Error al guardar contenido')
    }
}

export const closeSession = (sessionId) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/sessions/' + sessionId + '/close', {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message || 'Sesión cerrada correctamente')
            return true
        }
        return false
    } catch (error) {
        console.error('Error closeSession:', error)
        toastError(error.response?.data?.message || 'Error al cerrar sesion')
        return false
    }
}

export const addMaterial = (sessionId, material) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/sessions/' + sessionId + '/material', material, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message || 'Material adjuntado correctamente')
            return true
        }
        return false
    } catch (error) {
        console.error('Error addMaterial:', error)
        toastError(error.response?.data?.message || 'Error al adjuntar material')
        return false
    }
}

export const removeMaterial = (sessionId, materialId) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/teacher/sessions/' + sessionId + '/material/' + materialId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message || 'Material eliminado correctamente')
            return true
        }
        return false
    } catch (error) {
        console.error('Error removeMaterial:', error)
        toastError(error.response?.data?.message || 'Error al eliminar material')
        return false
    }
}

export const updateIncident = (sessionId, incidentId, incident) => async (dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/teacher/sessions/' + sessionId + '/incidents/' + incidentId, incident, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message || 'Incidencia actualizada correctamente')
            return true
        }
        return false
    } catch (error) {
        console.error('Error updateIncident:', error)
        toastError(error.response?.data?.message || 'Error al actualizar la incidencia')
        return false
    }
}

export const deleteIncident = (sessionId, incidentId) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/teacher/sessions/' + sessionId + '/incidents/' + incidentId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message || 'Incidencia eliminada correctamente')
            return true
        }
        return false
    } catch (error) {
        console.error('Error deleteIncident:', error)
        toastError(error.response?.data?.message || 'Error al eliminar la incidencia')
        return false
    }
}

export const addSessionIncident = (sessionId, incident) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/sessions/' + sessionId + '/incidents', incident, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message || 'Incidencia registrada correctamente')
            return true
        }
        return false
    } catch (error) {
        console.error('Error addSessionIncident:', error)
        toastError(error.response?.data?.message || 'Error al registrar la incidencia')
        return false
    }
}

export const getGroupStudents = (groupId) => async (dispatch) => {
    dispatch({ type: 'GROUP_STUDENTS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/groups/' + groupId + '/students', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'GROUP_STUDENTS_SUCCESS', payload: data.students })
        }
    } catch (error) {
        dispatch({ type: 'GROUP_STUDENTS_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getOrCreateSession = (groupId) => async (dispatch) => {
    dispatch({ type: 'DASHBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/groups/' + groupId + '/session', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_SUCCESS', payload: data.session })
        }
    } catch (error) {
        dispatch({ type: 'DASHBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getSessionDetail = (sessionId) => async (dispatch) => {
    dispatch({ type: 'SESSION_DETAIL_CLEAR' })
    dispatch({ type: 'DASHBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/session-detail/' + sessionId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_DETAIL_SUCCESS', payload: data })
        }
    } catch (error) {
        dispatch({ type: 'DASHBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getAvailableTeachers = () => async (dispatch) => {
    try {
        const { data, status } = await Axios.get('/api/teacher/substitutes/available', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'AVAILABLE_TEACHERS_SUCCESS', payload: data.teachers })
        }
    } catch (error) {
        console.error('Error getAvailableTeachers:', error)
    }
}

export const assignSubstitute = (sessionId, substituteTeacherId, substituteTeacherName) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/sessions/' + sessionId + '/substitute', {
            sessionId,
            substituteTeacherId,
            substituteTeacherName
        }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message)
            return true
        }
    } catch (error) {
        console.error('Error assignSubstitute:', error)
        toastError(error.response?.data?.message || 'Error al asignar sustituto')
        return false
    }
}

export const removeSubstitute = (sessionId) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/teacher/sessions/' + sessionId + '/substitute', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'SESSION_UPDATE', payload: data.session })
            toastSuccess(data.message)
            return true
        }
    } catch (error) {
        console.error('Error removeSubstitute:', error)
        toastError(error.response?.data?.message || 'Error al eliminar sustituto')
        return false
    }
}

export const getTeacherGroups = () => async (dispatch) => {
    dispatch({ type: 'DASHBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/groups/list', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'TEACHER_GROUPS_SUCCESS', payload: data.groups })
        }
    } catch (error) {
        dispatch({ type: 'DASHBOARD_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const assignGroupSubstitute = (groupId, groupName, substituteTeacherId, substituteTeacherName) => async (dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/teacher/groups/substitute', {
            groupId,
            groupName,
            substituteTeacherId,
            substituteTeacherName
        }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'GROUP_SUBSTITUTE_UPDATE', payload: { groupId, substitute: { id: substituteTeacherId, name: substituteTeacherName } } })
            toastSuccess(data.message)
            return true
        }
    } catch (error) {
        console.error('Error assignGroupSubstitute:', error)
        toastError(error.response?.data?.message || 'Error al asignar sustituto')
        return false
    }
}

export const removeGroupSubstitute = (groupId) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/teacher/groups/' + groupId + '/substitute', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'GROUP_SUBSTITUTE_UPDATE', payload: { groupId, substitute: null } })
            toastSuccess(data.message)
            return true
        }
    } catch (error) {
        console.error('Error removeGroupSubstitute:', error)
        toastError(error.response?.data?.message || 'Error al eliminar sustituto')
        return false
    }
}
